<template>
  <div>
    <div class="top__message">
      <b-container>
        <b-row class="justify-content-md-center">
          <b-col md="auto" class="d-none d-md-block" style="margin-top: auto; margin-bottom: auto;">
            <div class="top__auth">
              Trở thành <router-link :to="{ name: 'package-list' }" class="top__message__link">THÀNH VIÊN
                VIP</router-link> để học tập hiệu quả hơn cùng TryHSK
            </div>
          </b-col>

          <b-col md="auto" class="ml-auto">
            <div class="header__toolbar">
              <div class="bell__notification" v-if="isLoggedIn">
                <Notify />
              </div>
              <div v-if="!isLoggedIn"></div>
              <div v-else>
                <Wallet :size="16" color="white" :useIcon="true" />
              </div>
              <div class="top__auth" v-if="!isLoggedIn">
                <span class="auth__icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-circle-user-round">
                    <path d="M18 20a6 6 0 0 0-12 0" />
                    <circle cx="12" cy="10" r="4" />
                    <circle cx="12" cy="12" r="10" />
                  </svg>
                </span>
                <router-link :to="{ name: 'auth-login' }" class="auth__link">Đăng nhập</router-link>
                <span class="separator">|</span>
                <router-link :to="{ name: 'auth-register' }" class="auth__link">Đăng ký miễn phí</router-link>
              </div>
              <div class="top__profile" v-else>
                <b-dropdown :text="(user.name || user.email) ? user.name && user.name.length > 0 ? user.name : user.email : ''">
                  <b-dropdown-item :to="{ name: 'user-topup' }">Nạp tiền</b-dropdown-item>
                  <b-dropdown-item :to="{ name: 'user-exam-list' }">Đề thi của tôi</b-dropdown-item>
                  <b-dropdown-item :to="{ name: 'user-exam-recent' }">Đề thi đã làm</b-dropdown-item>
                  <b-dropdown-item :to="{ name: 'ma-kich-hoat' }">Mã kích hoạt</b-dropdown-item>
                  <b-dropdown-item :to="{ name: 'user-profile' }">Thông tin tài khoản</b-dropdown-item>
                  <b-dropdown-item :to="{ name: 'auth-logout' }">Đăng xuất</b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <b-container>
      <b-row class="justify-content-md-center align-items-center">
        <b-col xs="12" md="auto" class="mr-auto">
          <div class="logo">
            <a href="/"><img src="@/assets/logo.png" alt="HSK Online"></a>
          </div>
        </b-col>
        <b-col md="auto" class="d-none d-md-block">
          <b-form @submit="onSearch" class="search">
            <label class="sr-only" for="search">Keywords</label>
            <input type="text" class="form-control search__input" v-model="search.keyword" id="search"
              placeholder="Tìm kiếm đề thi">
            <button>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-search">
                <circle cx="11" cy="11" r="8" />
                <path d="m21 21-4.3-4.3" />
              </svg>
            </button>
          </b-form>
        </b-col>

      </b-row>
    </b-container>
    <div class="navigation">
      <b-container>
        <b-navbar toggleable="lg" class="p-0">
          <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

          <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav>
              <NavItem v-for="(item, index) in navItems" :key="index" :item="item" :isSubItem="false"></NavItem>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
      </b-container>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { checkResponse, get } from "@/utils/http"
import { APP_CONFIG } from '@/utils/constants'
import NavItem from './NavItem'
import Notify from './Notify'
import Wallet from '@/components/widgets/Wallet'


export default {
  name: 'Header',
  components: {
    NavItem,
    Notify,
    Wallet
  },
  data() {
    return {
      navItems: {},
      search: {
        keyword: ''
      }
    }
  },
  computed: {
    ...mapState('auth', ['isLoggedIn', 'user'])
  },
  methods: {
    async getMainMenu() {
      return await get(`${APP_CONFIG.apiUrl}/menu?position=main`)
        .then(checkResponse)
        .then((response) => {
          this.navItems = response.data.data;
        })
        .catch(() => {
          this.error = true;
        });
    },
    onSearch(evt) {
      evt.preventDefault()
      this.$router.push({ name: 'search', query: { s: this.search.keyword } })
    }
  },
  mounted() {
    this.getMainMenu();
  }
}
</script>